/* eslint-disable */
export default {
  button_html_google_sheet_add,
  postback_click_lang,
  message_sent_lang,
  message_sent_stat_error_lang,
  message_sent_stat_subscribers,
  message_sent_stat_delivered,

  http_api_name,
  http_api_socket_input_reply,
  http_api_socket_output_next,
  http_api_modal_title,
  http_api_list,
  http_api_create,
  http_api_edit,
  http_api_report,
  http_api_refresh,
  http_api_modal_error_msg,
  
  action_button_name,
  action_button_socket_output_next,

  action_button_html_title_action_button,
  action_button_html_title_messenger_engagement_plugin,
  action_button_html_title_select,

  action_button_html_actions_messenger_engagement_plugin,
  action_button_html_actions_get_started,
  action_button_html_actions_no_match,
  action_button_html_actions_unsubscribe,
  action_button_html_actions_resubscribe,
  action_button_html_actions_email,
  action_button_html_actions_phone,
  action_button_html_actions_location,
  action_button_html_actions_birthday,
  action_button_html_actions_with_human,
  action_button_html_actions_with_robot,

  action_button_html_plugin_type,
  action_button_html_domain,
  action_button_html_language,
  action_button_html_language_tooltip,

  action_button_html_cta_button_text,
  action_button_html_cta_button_text_tooltip,
  
  action_button_html_plugin_skin,
  action_button_html_plugin_skin_light,
  action_button_html_plugin_skin_dark,
  action_button_html_plugin_skin_white,
  action_button_html_plugin_skin_blue,
  action_button_html_plugin_skin_tooltip,

  action_button_html_center_align,
  action_button_html_center_align_yes,
  action_button_html_center_align_no,
  action_button_html_center_align_tooltip,

  action_button_html_plugin_size,
  action_button_html_plugin_size_small,
  action_button_html_plugin_size_medium,
  action_button_html_plugin_size_large,
  action_button_html_plugin_size_xlarge,
  action_button_html_plugin_size_standard,
  action_button_html_plugin_size_tooltip,

  action_button_html_redirect_to_a_webpage_on_successful_optin,
  
  action_button_html_optin_success_redirect_url,
  action_button_html_optin_success_redirect_url_tooltip,
  
  action_button_html_optin_success_message_in_website,
  action_button_html_optin_success_message_in_website_textarea_placeholder,
  action_button_html_optin_success_message_in_website_textarea_default_message,
  
  action_button_html_i_want_to_add_a_button_in_success_message,

  action_button_html_button_text,
  action_button_html_button_text_tooltip,

  action_button_html_button_url,
  action_button_html_button_url_tooltip,

  action_button_html_button_background,
  action_button_html_button_text_color,
  action_button_html_button_hover_background,
  action_button_html_button_text_hover_color,

  action_button_html_button_size,
  action_button_html_button_size_small,
  action_button_html_button_size_medium,
  action_button_html_button_size_large,
  action_button_html_button_size_extra_large,
  action_button_html_button_size_tooltip,

  action_button_html_checkbox_validation_error_message,
  action_button_html_checkbox_validation_error_message_tooltip,

  action_button_html_chat_plugin_loading,
  action_button_html_chat_plugin_loading_hide,
  action_button_html_chat_plugin_loading_show,
  action_button_html_chat_plugin_loading_fade,
  action_button_html_chat_plugin_loading_tooltip,

  action_button_html_loading_delay_seconds,
  action_button_html_loading_delay_seconds_tooltip,

  action_button_html_theme_color,
  action_button_html_theme_color_tooltip,

  action_button_html_do_not_show_if_not_logged_in,
  action_button_html_do_not_show_if_not_logged_in_yes,
  action_button_html_do_not_show_if_not_logged_in_no,
  action_button_html_do_not_show_if_not_logged_in_tooltip,

  action_button_html_greeting_text_if_logged_in_to_facebook,
  action_button_html_greeting_text_if_logged_in_to_facebook_tooltip,
  action_button_html_greeting_text_if_logged_in_to_facebook_placeholder,
  
  action_button_html_greeting_text_if_not_logged_in_to_facebook,
  action_button_html_greeting_text_if_not_logged_in_to_facebook_tooltip,
  action_button_html_greeting_text_if_not_logged_in_to_facebook_placeholder,
  
  action_button_html_reference,
  action_button_html_reference_tooltip,

  action_button_html_select_labels,
  action_button_html_select_labels_tooltip,

  action_button_html_actions_story_mention,
  action_button_html_actions_story_private_reply,
  action_button_html_actions_message_unsend_private_reply,

  action_button_html_messenger_engagement_plugin_checkbox_plugin, 
  action_button_html_messenger_engagement_plugin_send_to_messenger, 
  action_button_html_messenger_engagement_plugin_m_me_link, 
  action_button_html_messenger_engagement_plugin_customer_chat_plugin, 

  action_button_modal_title,
  action_button_modal_msg_action_type,
  action_button_modal_msg_has_action_buttons,
  
  action_button_modal_msg_plugin_type,
  action_button_modal_msg_domain,
  action_button_modal_msg_language,

  action_button_modal_msg_plugin_skin,
  action_button_modal_msg_plugin_size,
  
  action_button_modal_msg_plugin_redirection_status,
  
  action_button_modal_msg_button_text,
  action_button_modal_msg_button_url,
  
  action_button_modal_msg_button_attributes,
  action_button_modal_msg_plugin_center_align,
  
  action_button_modal_msg_cta_button_type,
  action_button_modal_msg_button_size,
  
  action_button_modal_msg_chat_plugin_loading_status,
  action_button_modal_msg_chat_plugin_theme_color,

  action_button_modal_msg_hide_chat_plugin_if_not_logged_in,
  
  action_button_modal_msg_reference,

  audio_name,
  audio_socket_input_reply,
  audio_socket_output_next,
  audio_socket_output_quick_replies,
  audio_html_label_media_url,
  audio_html_ph_media_url,
  audio_html_info_supported_media,
  audio_modal_title,
  audio_modal_msg_required_media,

  button_name,
  button_socket_input_reply,
  button_socket_output_next,
  button_socket_output_sequence,
  button_html_title_select,
  
  button_html_label_button_text,
  button_html_label_webhook_url,
  button_html_label_action_type,
  button_html_label_button_type,
  button_html_label_postback_id,
  button_html_label_web_url,
  button_html_label_mobile,
  button_html_label_webview_url,
  button_html_add_label,
  button_html_remove_label,
  button_html_add_sequence,
  button_html_remove_sequence,
  button_html_conversation_user,
  button_html_conversation_group,
  
  button_html_types_postback_new,
  button_html_types_postback,
  button_html_types_system_default,
  button_html_types_web_url,
  button_html_types_web_url_full,
  button_html_types_web_url_compact,
  button_html_types_web_url_tall,
  button_html_types_web_url_birthday,
  button_html_types_web_url_email,
  button_html_types_web_url_phone,
  button_html_types_web_url_location,
  button_html_types_phone_number,
  button_html_types_unsubscribe,
  button_html_types_resubscribe,
  button_html_types_with_human,
  button_html_types_with_robot,
  
  button_modal_title,
  button_modal_msg_button_name,
  button_modal_msg_button_type,
  button_modal_msg_action_type,
  button_modal_msg_postback_id,
  button_modal_msg_web_url,
  button_modal_msg_webview_url,
  button_modal_msg_mobile,

  carousel_name,
  carousel_socket_input_reply,
  carousel_socket_output_next,
  carousel_socket_output_items,
  carousel_socket_output_quick_replies,
  carousel_modal_title,

  carousel_item_name,
  carousel_item_socket_input_reply,
  carousel_item_socket_output_buttons,
  carousel_item_html_label_reply_img,
  carousel_item_html_label_destination_link,
  carousel_item_html_label_img_link,
  carousel_item_html_label_title,
  carousel_item_html_label_subtitle,

  carousel_item_html_ph_media_url,
  carousel_item_html_info_supported_img,

  carousel_item_modal_title,
  carousel_item_modal_msg_title,

  condition_name,
  condition_socket_input_reply,
  condition_socket_output_true,
  condition_socket_output_false,
  condition_html_title_select,
  condition_html_label_all_match,
  condition_html_label_any_match,
  condition_html_label_system_field,
  condition_html_label_custom_field,
  condition_html_label_variable,
  condition_html_label_operator,
  condition_html_label_gender,
  condition_html_label_value,
  condition_html_label_contact_group_id,

  condition_html_gender_male,
  condition_html_gender_female,

  condition_html_operators_system_contains,
  condition_html_operators_system_start_with,
  condition_html_operators_system_end_with,
  condition_html_operators_system_has_value,

  condition_html_variables_system_gender,
  condition_html_variables_system_first_name,
  condition_html_variables_system_last_name,
  condition_html_variables_system_contact_group_id,
  condition_html_variables_system_email,
  condition_html_variables_system_phone_number,

  condition_modal_title,
  condition_modal_msg_duplicates_system_field,
  condition_modal_msg_required_equal_operator,
  condition_modal_msg_gender_type,
  condition_modal_msg_label,
  condition_modal_msg_operator_system_field,
  condition_modal_msg_variable_value_system_field,

  condition_modal_msg_duplicates_custom_field,
  condition_modal_msg_operator_custom_field,
  condition_modal_msg_variable_value_custom_field,

  condition_template_all,
  condition_template_any,
  condition_template_match_type,
  condition_template_system_field,
  condition_template_custom_field,
  condition_template_operator,
  condition_template_variable,
  condition_template_value,

  ecommerce_name,
  ecommerce_socket_input_reply,
  ecommerce_socket_output_next,
  ecommerce_socket_output_quick_replies,
  ecommerce_html_title_select,
  ecommerce_html_label_store,
  ecommerce_html_label_products,
  ecommerce_html_label_button_name,

  ecommerce_modal_title,
  ecommerce_modal_msg_store,
  ecommerce_modal_msg_product,
  ecommerce_modal_msg_button_name,

  facebook_media_name,
  facebook_media_socket_input_reply,
  facebook_media_socket_output_next,
  facebook_media_socket_output_buttons,
  facebook_media_socket_output_quick_replies,
  facebook_media_html_label_media_url,
  facebook_media_html_placeholder_page_example,

  facebook_media_modal_title,
  facebook_media_modal_msg_media_url,

  file_name,
  file_socket_input_reply,
  file_socket_output_next,
  file_socket_output_quick_replies,
  file_html_label_media_url,
  file_html_ph_media_url,
  file_html_info_supported_media,

  file_modal_title,
  file_modal_msg_file,

  generic_template_name,
  generic_template_socket_input_reply,
  generic_template_socket_output_next,
  generic_template_socket_output_buttons,
  generic_template_socket_output_quick_replies,
  generic_template_html_label_reply_img_url,
  generic_template_html_label_dest_img_link,
  generic_template_html_label_title,
  generic_template_html_label_subtitle,
  generic_template_html_placeholder_reply_img_url,
  generic_template_html_info_supported_media,

  generic_template_modal_title,
  generic_template_modal_msg_title,

  image_name,
  image_socket_input_reply,
  image_socket_output_next,
  image_socket_output_quick_replies,
  image_html_label_img_media_url,
  image_html_placeholder_img_url,
  image_html_info_supported_media,

  image_modal_title,
  image_modal_msg_image,

  postback_new_name,
  postback_new_socket_input_trigger,
  postback_new_socket_input_reply,
  postback_new_socket_output_next,
  postback_new_socket_output_sequence,
  postback_new_html_label_title,
  postback_new_html_label,
  postback_new_html_sequence,

  postback_new_html_info_sequence,

  postback_new_modal_title,
  postback_new_modal_msg_title,

  otn_name,
  otn_socket_input_reply,
  otn_socket_output_next,
  otn_html_label_title,
  otn_html_label_postback_id,
  otn_html_sequence_info,

  otn_modal_title,
  otn_modal_msg_title,
  otn_modal_msg_postback_id,

  otn_single_modal_title,
  otn_single_modal_template_name_msg,

  otn_single_name,
  otn_single_socket_input_reply,
  otn_single_socket_output_next,
  otn_single_socket_output_next_sequence,

  otn_single_html_template_name,
  otn_single_html_labels,
  otn_single_html_sequence,
  otn_single_html_sequence_info,

  otn_single_template_template_name,
  otn_single_template_labels,
  otn_single_template_sequence_name,

  Rcn_name,
  Rcn_socket_input_reply,
  Rcn_socket_output_next,
  Rcn_modal_title,
  Rcn_html_label_title,
  Rcn_html_label_postback_id,
  Rcn_html_sequence_info,
  Rcn_modal_title,
  Rcn_modal_msg_title,
  Rcn_modal_msg_postback_id,
  Rcn_html_daily,
  Rcn_html_weekly,
  Rcn_html_monthly,
  Rcn_html_recursion_type,

  Rcn_single_modal_title,
  Rcn_single_modal_template_name_msg,
  Rcn_html_label_img_media_url,

  Rcn_single_name,
  Rcn_single_socket_input_reply,
  Rcn_single_socket_output_next,
  Rcn_single_socket_output_next_sequence,

  Rcn_single_html_template_name,
  Rcn_single_html_labels,
  Rcn_single_html_sequence,
  Rcn_single_html_sequence_info,

  Rcn_single_template_template_name,
  Rcn_single_template_labels,
  Rcn_single_template_sequence_name,


  quick_reply_name,
  quick_reply_socket_input_reply,
  quick_reply_socket_output,
  quick_reply_socket_output_sequence,
  quick_reply_html_title_select,
  quick_reply_html_label_reply_type,
  quick_reply_html_label_button_text,
  quick_reply_html_label_postback_id,

  quick_reply_html_reply_types_newPostback,
  quick_reply_html_reply_types_postback,
  quick_reply_html_reply_types_phone,
  quick_reply_html_reply_types_email,

  quick_reply_modal_title,
  quick_reply_modal_msg_reply_type,
  quick_reply_modal_msg_button_text,
  quick_reply_modal_msg_postback_id,

  postback_name,
  postback_socket_input_trigger,
  postback_socket_input_action_button,
  postback_socket_output_next,
  postback_html_label_title,
  postback_html_label_label,
  postback_html_label_create_new,
  postback_html_label_create_new_info,
  postback_html_label_could_not_create,
  postback_html_label_sequence,

  postback_modal_title,
  postback_modal_msg_title,

  sequence_name,
  sequence_socket_input_reply,
  sequence_socket_output_next,
  sequence_html_title_select,
  sequence_html_label_name,
  sequence_html_label_start_time,
  sequence_html_label_closing_time,
  sequence_html_label_timezone,
  sequence_html_label_message_tag,

  sequence_html_info_non_promotional_requirements,
  sequence_modal_title,
  sequence_modal_msg_name,

  sequence_template_start_time,
  sequence_template_closing_time,
  sequence_template_timezone,
  sequence_template_message_tag,

  sequence_single_name,
  sequence_single_socket_input_reply,
  sequence_single_socket_output_next,

  sequence_single_html_title_select,
  sequence_single_html_title_daily,
  sequence_single_html_title_hours_24,

  sequence_single_html_label_promotional,
  sequence_single_html_label_non_promotional,
  sequence_single_html_label_hours,
  sequence_single_html_label_days,

  sequence_single_html_hours_min_1,
  sequence_single_html_hours_mins_5,
  sequence_single_html_hours_mins_15,
  sequence_single_html_hours_mins_30,
  sequence_single_html_hours_mins_45,
  sequence_single_html_hours_hour_1,
  sequence_single_html_hours_hours_2,
  sequence_single_html_hours_hours_3,
  sequence_single_html_hours_hours_4,
  sequence_single_html_hours_hours_5,
  sequence_single_html_hours_hours_6,
  sequence_single_html_hours_hours_7,
  sequence_single_html_hours_hours_8,
  sequence_single_html_hours_hours_9,
  sequence_single_html_hours_hours_10,
  sequence_single_html_hours_hours_11,
  sequence_single_html_hours_hours_12,
  sequence_single_html_hours_hours_13,
  sequence_single_html_hours_hours_14,
  sequence_single_html_hours_hours_15,
  sequence_single_html_hours_hours_16,
  sequence_single_html_hours_hours_17,
  sequence_single_html_hours_hours_18,
  sequence_single_html_hours_hours_19,
  sequence_single_html_hours_hours_20,
  sequence_single_html_hours_hours_21,
  sequence_single_html_hours_hours_22,
  sequence_single_html_hours_hours_23,

  sequence_single_html_days_day_1,
  sequence_single_html_days_day_2,
  sequence_single_html_days_day_3,
  sequence_single_html_days_day_4,
  sequence_single_html_days_day_5,
  sequence_single_html_days_day_6,
  sequence_single_html_days_day_7,
  sequence_single_html_days_day_8,
  sequence_single_html_days_day_9,
  sequence_single_html_days_day_10,
  sequence_single_html_days_day_11,
  sequence_single_html_days_day_12,
  sequence_single_html_days_day_13,
  sequence_single_html_days_day_14,
  sequence_single_html_days_day_15,
  sequence_single_html_days_day_16,
  sequence_single_html_days_day_17,
  sequence_single_html_days_day_18,
  sequence_single_html_days_day_19,
  sequence_single_html_days_day_20,
  sequence_single_html_days_day_21,
  sequence_single_html_days_day_22,
  sequence_single_html_days_day_23,
  sequence_single_html_days_day_24,
  sequence_single_html_days_day_25,
  sequence_single_html_days_day_26,
  sequence_single_html_days_day_27,
  sequence_single_html_days_day_28,
  sequence_single_html_days_day_29,
  sequence_single_html_days_day_30,

  sequence_single_modal_title,
  sequence_single_modal_msg_promotional,
  sequence_single_modal_msg_non_promotional,
  sequence_single_modal_msg_promotional_or_non_promotional,

  text_name,
  text_socket_input_reply,
  text_socket_output_next,
  text_socket_output_buttons,
  text_socket_output_quick_replies,

  text_html_title_custom,
  text_html_title_first_name,
  text_html_title_last_name,

  text_html_label_reply_message,
  text_html_info_custom_variable,
  text_html_info_firstname,
  text_html_info_lastname,
  
  text_html_instagram_tag,
  text_html_instagram_username,
  text_html_instagram_username_info,

  text_modal_title,
  text_modal_msg_reply_message,

  text_with_buttons_name,

  openai_name,
  openai_modal_title,
  openai_modal_msg_reply_message,
  openai_html_label_reply_message,

  trigger_name,

  trigger_html_label_keywords,
  trigger_html_placeholder_keywords,
  trigger_html_info_keywords,
  trigger_html_matching_type,
  trigger_html_exact_match,
  trigger_html_string_match,

  trigger_modal_title,
  trigger_modal_msg_keywords,

  user_input_flow_name,
  user_input_flow_socket_input_reply,
  user_input_flow_socket_input_questions,
  user_input_flow_html_label_flow,
  user_input_flow_html_label_campaign,
  
  user_input_flow_modal_title,
  user_input_flow_modal_msg_flow,
  
  user_input_flow_single_name,
  user_input_flow_single_socket_input_reply,
  user_input_flow_single_socket_output_next,
  user_input_flow_single_socket_output_final_reply,
  
  user_input_flow_single_html_question_type,
  user_input_flow_single_html_question_type_keyboard,
  user_input_flow_single_html_question_type_multiple,
  
  user_input_flow_single_html_question, 
  user_input_flow_single_html_question_placeholder, 
  user_input_flow_single_html_question_option1_placeholder, 
  user_input_flow_single_html_question_option2_placeholder,
  user_input_flow_single_html_question_option3_placeholder,
  user_input_flow_single_html_question_option4_placeholder,
  user_input_flow_single_html_question_another_option_placeholder,
  user_input_flow_single_html_question_option_add_more,
  
  user_input_flow_single_html_reply_type,
  user_input_flow_single_html_reply_type_email,
  user_input_flow_single_html_reply_type_phone,
  user_input_flow_single_html_reply_type_text,
  user_input_flow_single_html_reply_type_number,
  user_input_flow_single_html_reply_type_url,
  user_input_flow_single_html_reply_type_file,
  user_input_flow_single_html_reply_type_image,
  user_input_flow_single_html_reply_type_video,
  user_input_flow_single_html_reply_type_date,
  user_input_flow_single_html_reply_type_time,
  user_input_flow_single_html_reply_type_datetime,
  
  user_input_flow_single_html_quick_reply_email,
  user_input_flow_single_html_quick_reply_phone,
  
  user_input_flow_single_html_custom_field,
  user_input_flow_single_html_system_field,

  user_input_flow_single_html_system_field_select,
  user_input_flow_single_html_system_field_email,
  user_input_flow_single_html_system_field_phone,
  user_input_flow_single_html_system_field_birthday,
  user_input_flow_single_html_system_field_location,
  
  user_input_flow_single_html_assign_to_labels,
  user_input_flow_single_html_assign_to_labels_create_new,
  user_input_flow_single_html_assign_to_labels_create_new_info,
  user_input_flow_single_html_assign_to_messenger_sequence,
  user_input_flow_single_html_assign_to_email_phone_sequence,
  
  user_input_flow_single_html_skip_button_text,
  user_input_flow_single_html_skip_button_text_placeholder,
  
  user_input_flow_single_modal_title,
  
  user_input_flow_single_modal_msg_question_type,
  user_input_flow_single_modal_msg_question,
  user_input_flow_single_modal_msg_multiple_choices,
  
  user_input_flow_single_template_question,
  user_input_flow_single_template_options,
  user_input_flow_single_template_reply_type,
  user_input_flow_single_template_quick_reply_email,
  user_input_flow_single_template_quick_reply_phone,
  user_input_flow_single_template_quick_reply_answer_yes,
  user_input_flow_single_template_custom_field,
  user_input_flow_single_template_system_field,
  user_input_flow_single_template_assign_to_labels,
  user_input_flow_single_template_assign_to_messenger_sequence,
  user_input_flow_single_template_assign_to_email_phone_sequence,
  user_input_flow_single_template_skip_button_text,

  video_name,
  video_socket_input_reply,
  video_socket_output_next,
  video_socket_output_quick_replies,
  video_html_label_video_url,
  video_html_placeholder_video_url,
  video_html_info_supported_media,

  video_modal_title,
  video_modal_msg_video,

  delay_html_label_typing_display,
  delay_html_label_delay_in_reply,

  delay_html_info_sec,
  delay_html_msg_delay_range,

  common_button_ok,
  common_button_cancel,

  common_info_sec,
  common_info_error,
  common_info_success,
  common_info_warning,
  common_info_typing_display,
  common_info_audio_not_supported,
  common_info_video_not_supported,

  others_buttons_title_back,
  others_buttons_title_rearrange,
  others_buttons_title_save_only,
  others_buttons_title_save,
  others_buttons_title_success,

  others_buttons_msg_components_required,
  others_buttons_msg_components_components_connection_required,
  others_buttons_msg_components_components_data_required,
  others_buttons_msg_components_new_postback_next_connection_required,
  others_buttons_msg_components_non_promotional_data_required,

  utils_title_success,
  utils_title_warning,
  utils_title_info,
  utils_title_error,

  utils_button_ok,
  utils_button_cancel,

  swal_button_ok,
  swal_button_cancel,

  plugin_component,
  plugin_components,
  plugin_incompatible_connection,
  plugin_incompatible_connection_user_input_flow_builder,
  plugin_incompatible_connection_otn_single,
  plugin_connection_limit,
  plugin_recursion_problem,
}